import { useContext, useCallback } from 'react';
import * as lodash from 'lodash';
import { AjaxContext, AppContext, EMPTY_ARRAY, ERROR_SEVERITY, EApiResponseCode } from 'commons-ui';
import { EDelinkUserURL } from './helper';

const useService = () => {
	const { postData } = useContext(AjaxContext);
	const {
		app: { appName }
	} = useContext(AppContext);

	const delinkUserByPhone = useCallback(async (zupeeUserId: string, showAlert: any): Promise<boolean> => {
		try {
			const response = await postData({
				endpoint: EDelinkUserURL.DELINK_USER,
				queryParams: {
					appName
				},
				body: {
					zupeeUserId
				}
			});
			if (response.status !== EApiResponseCode.SUCCESS) {
				showAlert('Internal server error', { type: ERROR_SEVERITY.ERROR });
				return false;
			}
			if (response?.data?.success === false) {
				showAlert(`${lodash.get(response, ['data', 'externalMessage'], 'Error in api')}`, { type: ERROR_SEVERITY.ERROR });
				return false;
			}
		} catch (error: any) {
			showAlert('Some error occured', { type: ERROR_SEVERITY.ERROR });
			return false;
		}
		return true;
	}, EMPTY_ARRAY);

	return {
		delinkUserByPhone
	};
};

export default useService;
